import { Dictionary } from '../../../config/locale/locale';
import { LEGACY_LINK_TYPE_ALIASES, LinkType } from '../../../constants/enums';
import { getLinkTypeIconPath } from '../../../constants/icons';

export { getLinkTypeIconPath };

export function isExternalLinkType(linkType?: string): boolean {
  if (!linkType) return true;
  const lower = linkType.toLowerCase();
  return lower !== LinkType.INTERNAL && lower !== LEGACY_LINK_TYPE_ALIASES.INTERNAL;
}

export function getLinkTypeLabel(linkType: string | undefined, t: Dictionary): string {
  if (!linkType) return t.mods.linkTypes.external;
  const lower = linkType.toLowerCase();
  switch (lower) {
    case LinkType.INTERNAL:
    case LEGACY_LINK_TYPE_ALIASES.INTERNAL:
      return t.mods.linkTypes.internal;
    case LinkType.EXTERNAL:
    case LEGACY_LINK_TYPE_ALIASES.EXTERNAL:
      return t.mods.linkTypes.external;
    case LinkType.WEB:
      return t.mods.linkTypes.web;
    case LinkType.GITHUB:
      return t.mods.linkTypes.github;
    case LinkType.COMMUNITY:
      return t.mods.linkTypes.community;
    case LinkType.DISCORD:
      return t.mods.linkTypes.discord;
    case LinkType.OTHER:
      return t.mods.linkTypes.other;
    default:
      return t.mods.linkTypes.external;
  }
}
